module.exports = __webpack_public_path__ + "static/total-recall-be368014ec741e94f503447024497967.jpg";